import script from "./SpecialNoteInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./SpecialNoteInput.vue?vue&type=script&lang=ts&setup=true"

import "./SpecialNoteInput.vue?vue&type=style&index=0&id=72a31baf&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72a31baf"]])

export default __exports__